module.exports = __webpack_public_path__ + "static/media/month_09.741f78ed.png";